module.exports = __webpack_public_path__ + "media/images/athletes/3530-462b12831e7289d9538efe6554d0de22.png";